import React from 'react';
import { Instagram, Mail, Facebook, MessageCircle } from 'lucide-react';

const OrderCTA = ({ title = "Ready to Place a Custom Order?" }) => {
    return (
        <section className="bg-accent py-10">
            <div className="max-w-7xl mx-auto px-4 text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">{title}</h2>
                <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
                    We specialize in B2B and custom manufacturing. Contact us directly to discuss your requirements.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-4xl mx-auto">
                    <a
                        href="https://wa.me/923318689110"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-4 rounded-lg hover:opacity-90 transition font-semibold shadow-md"
                    >
                        <MessageCircle size={20} />
                        WhatsApp
                    </a>

                    <a
                        href="https://instagram.com/YOUR_HANDLE"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-4 rounded-lg hover:opacity-90 transition font-semibold shadow-md"
                    >
                        <Instagram size={20} />
                        Instagram
                    </a>

                    <a
                        href="https://facebook.com/YOUR_PAGE"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 bg-[#1877F2] text-white px-6 py-4 rounded-lg hover:opacity-90 transition font-semibold shadow-md"
                    >
                        <Facebook size={20} />
                        Facebook
                    </a>

                    <a
                        href="mailto:info@threadneedlevalley.com"
                        className="flex items-center justify-center gap-2 bg-dark text-white px-6 py-4 rounded-lg hover:bg-gray-800 transition font-semibold shadow-md"
                    >
                        <Mail size={20} />
                        Email Us
                    </a>
                </div>
            </div>
        </section>
    );
};

export default OrderCTA;
